<template>
  <b-container fluid>
    <b-row>
      <!-- <b-col lg="12" md="12" sm="12">
        <iq-card class-name="iq-card-block iq-card-stretch" body-class="">
          <template v-slot:body>
            {{ getRPBelongsToUser.id }}
          </template>
        </iq-card>
      </b-col> -->
      <b-col lg="12">
        <iq-card
          class-name="iq-card-block iq-card-stretch iq-card-height"
          body-class="row m-0 align-items-center pb-0"
        >
          <template v-slot:headerTitle>
            <div>
              <b-button
                class="mr-2"
                :class="{ primary: isRecordType }"
                @click="fnSelectRecordType()"
                >Settlements</b-button
              >
              <b-button
                class="mr-2"
                :class="{ primary: !isRecordType }"
                @click="fnSelectRecordType()"
                >Leads</b-button
              >

              <b-spinner
                v-if="getDRIsDashboardLoading"
                label="Loading..."
                small
              ></b-spinner>
            </div>
          </template>
          <template v-slot:headerAction>
            <ul class="nav nav-pills">
              <li class="nav-item">
                <a
                  href="javascript:void(0);"
                  class="nav-link"
                  :class="{ active: periodMode == 'this-month' }"
                  @click="fnPeriod('this-month')"
                  >This month</a
                >
              </li>
              <li class="nav-item">
                <a
                  href="javascript:void(0);"
                  class="nav-link"
                  :class="{ active: periodMode == 'last-month' }"
                  @click="fnPeriod('last-month')"
                  >Last month</a
                >
              </li>
              <li class="nav-item">
                <a
                  href="javascript:void(0);"
                  class="nav-link"
                  :class="{ active: periodMode == 'this-year' }"
                  @click="fnPeriod('this-year')"
                  >This year</a
                >
              </li>
            </ul>
          </template>
          <template v-slot:body>
            <b-col md="8">
              <div
                v-if="periodMode == 'this-month' && dataObj1 && dataObj1.labels"
              >
                <appBarChart :dataObj="dataObj1"></appBarChart>
              </div>
              <div
                v-if="periodMode == 'last-month' && dataObj2 && dataObj2.labels"
              >
                <appBarChart :dataObj="dataObj2"></appBarChart>
              </div>
              <div
                v-if="periodMode == 'this-year' && dataObj3 && dataObj3.labels"
              >
                <appBarChart :dataObj="dataObj3"></appBarChart>
              </div>
            </b-col>

            <b-col md="4">
              <appWDDashboardSummaryRp
                v-if="periodMode == 'this-month' && dataObj1"
                :dataObj="dataObj1"
                :periodMode="'this-month'"
                :isRecordType="isRecordType"
              ></appWDDashboardSummaryRp>

              <appWDDashboardSummaryRp
                v-if="periodMode == 'last-month' && dataObj2"
                :dataObj="dataObj2"
                :periodMode="'last-month'"
                :isRecordType="isRecordType"
              ></appWDDashboardSummaryRp>

              <appWDDashboardSummaryRp
                v-if="periodMode == 'this-year' && dataObj3"
                :dataObj="dataObj3"
                :periodMode="'this-year'"
                :isRecordType="isRecordType"
              ></appWDDashboardSummaryRp>
            </b-col>
          </template>
        </iq-card>
      </b-col>

      <!-- Video guide -->
      <b-col lg="12">
        <iq-card class-name="iq-card-block iq-card-stretch iq-card-height">
          <template v-slot:headerTitle>
            <h4 class="card-title">Video guide</h4>
          </template>
          <template v-slot:body>
            <b-row>
              <b-col lg="2" v-for="(video, index) in videos" :key="index">
                <appVideoPlaceHolder
                  :title="video.title"
                  :coverImgUrl="video.imageUrl"
                  :videoUrl="video.url"
                ></appVideoPlaceHolder>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { findash } from '../../config/pluginInit'
import moment from 'moment'
import bgImage from '../../assets/images/page-img/45.png'
import appVideoPlaceHolder from '../../components/wd/VideoPlaceHolder.vue'
import { mapGetters, mapActions } from 'vuex'
import appChartBox from '../../components/charts/ChartBox.vue'
import appBarChart from '../../components/charts/BarChart.vue'
import * as authService from '../../services/auth.service'
import appWDDashboardSummaryRp from '../../components/wd/WDDashboardSummaryRp.vue'
import {
  fnGetThisMonthData,
  fnGetLastMonthData,
  fnGetDashboardInformation,
  fnGetThisMonthLeadsData,
  fnGetLastMonthLeadsData,
  fnGetDashboardLeadsInformation
} from '../../Utils/dashboardReferralPartner'

export default {
  name: 'DashboardDealer',
  components: {
    appVideoPlaceHolder,
    appChartBox,
    appBarChart,
    appWDDashboardSummaryRp
  },
  mounted() {
    findash.index()
    setTimeout(() => this.fnPeriod(this.periodMode), 3000)
  },
  data() {
    return {
      videos: [
        {
          title: 'What is a Novated Lease',
          imageUrl: require('../../assets/images/video-tutorials/f1.jpg'),
          url: '/videos/music_novated_lease_explained.mp4'
        },
        {
          title: 'Save Tax & GST',
          imageUrl: require('../../assets/images/video-tutorials/f2.jpg'),
          url: '/videos/novated_lease_savings.mp4'
        },
        {
          title: 'SA Government Employees',
          imageUrl: require('../../assets/images/video-tutorials/f3.jpg'),
          url: '/videos/sa_government_employees.mp4'
        },
        {
          title: 'Options at the end of the lease',
          imageUrl: require('../../assets/images/video-tutorials/f4.jpg'),
          url: '/videos/options_at_the_end_of_the_lease.mp4'
        },
        {
          title: 'Which employees can we assist',
          imageUrl: require('../../assets/images/video-tutorials/f5.jpg'),
          url: '/videos/which_employees_can_we_asist_with_novated_leasing.mp4'
        }
        // {
        //   title: 'Move Your Body',
        //   imageUrl: require('../../assets/images/video-tutorials/f5.jpg'),
        //   url: 'https://www.youtube.com/watch?v=fNfe6WdXRdA'
        // },
        // {
        //   title: 'Try New Things',
        //   imageUrl: require('../../assets/images/video-tutorials/f6.jpg'),
        //   url: 'https://www.youtube.com/watch?v=s4ObxcdXoFE'
        // }
      ],
      getRPBelongsToUser: [],
      dataSettlements: [],
      periodMode: 'this-month',
      dataObj1: '',
      dataObj2: '',
      dataObj3: '',
      bgImageURL: bgImage,
      userObj: {},
      currentMonthInText: '',
      lastMonthInText: '',
      currentYearInText: '',
      isRecordType: true
    }
  },
  computed: {
    ...mapGetters([
      'getUserById',
      'getDRIsDashboardLoading',
      'getDRpThisMonthData',
      'getDRpLastMonthData',
      'getDRpLastYearData',
      'getDRpThisMonthLeadsData',
      'getDRpLastMonthLeadsData',
      'getDRpLastYearLeadsData'
    ])
  },
  methods: {
    ...mapActions([
      'fetchUserById',
      'fetchDRpThisMonthData',
      'fetchDRpLastMonthData',
      'fetchDRpLastYearData',
      'fetchDRpThisMonthLeadsData',
      'fetchDRpLastMonthLeadsData',
      'fetchDRpLastYearLeadsData'
    ]),

    fnSelectRecordType() {
      this.isRecordType = !this.isRecordType
      this.fnPeriod(this.periodMode)

      return this.isRecordType
    },

    // This month data
    fnPeriodThisMonth() {
      let thisMonthData = fnGetThisMonthData(
        this.getDRpThisMonthData.data_settlement_quote
      )

      let obj = {
        series: [
          {
            data: thisMonthData.dataSettlements,
            name: ['Settlements']
          }
        ],
        labels: thisMonthData.dataLabels,
        colors: ['#1e3d73'],
        dataTotSettlement: thisMonthData.dataTotSettlement,
        dataTotInc: thisMonthData.dataTotInc
      }
      this.dataObj1 = obj
    },

    // Last month data
    fnPeriodLastMonth() {
      let lastMonthData = fnGetLastMonthData(
        this.getDRpLastMonthData.data_settlement_quote
      )

      let obj = {
        series: [
          {
            data: lastMonthData.dataSettlements,
            name: ['Settlements']
          }
        ],
        labels: lastMonthData.dataLabels,
        colors: ['#1e3d73'],
        dataTotSettlement: lastMonthData.dataTotSettlement,
        dataTotInc: lastMonthData.dataTotInc
      }
      this.dataObj2 = obj
    },

    // Last year data
    fnPeriodLastYear() {
      let thisYearData = fnGetDashboardInformation(
        this.getDRpLastYearData.data_settlement_quote
      )
      let obj = {
        series: [
          {
            data: thisYearData.dataSettlements,
            name: ['Settlements']
          }
        ],
        labels: thisYearData.dataLabels,
        colors: ['#1e3d73'],
        dataTotSettlement: thisYearData.dataTotSettlement,
        dataTotInc: thisYearData.dataTotInc
      }
      this.dataObj3 = obj
    },

    // This month all Leads
    fnPeriodThisMonthLeads() {
      let thisMonthData = fnGetThisMonthLeadsData(
        this.getDRpThisMonthLeadsData.data
      )

      let obj = {
        series: [
          {
            data: thisMonthData.dataQuotes,
            name: ['Leads']
          }
        ],
        labels: thisMonthData.dataLabels,
        colors: ['#1e3d73'],
        dataTotQuotes: thisMonthData.dataTotQuotes
      }
      this.dataObj1 = obj
    },

    // Last month all Leads
    fnPeriodLastMonthLeads() {
      let lastMonthData = fnGetLastMonthLeadsData(
        this.getDRpLastMonthLeadsData.data
      )

      let obj = {
        series: [
          {
            data: lastMonthData.dataQuotes,
            name: ['Leads']
          }
        ],
        labels: lastMonthData.dataLabels,
        colors: ['#1e3d73'],
        dataTotQuotes: lastMonthData.dataTotQuotes
      }
      this.dataObj2 = obj
    },

    // Last year all Leads
    fnPeriodLastYearLeads() {
      let thisYearData = fnGetDashboardLeadsInformation(
        this.getDRpLastYearLeadsData.data
      )
      let obj = {
        series: [
          {
            data: thisYearData.dataQuotes,
            name: ['Leads']
          }
        ],
        labels: thisYearData.dataLabels,
        colors: ['#1e3d73'],
        dataTotQuotes: thisYearData.dataTotQuotes
      }
      this.dataObj3 = obj
    },

    fnPeriod(periodMode) {
      this.periodMode = periodMode

      if (this.isRecordType && this.periodMode == 'this-month') {
        this.isThisMonthActive = true
        this.fnPeriodThisMonth()
      } else if (this.isRecordType && this.periodMode == 'last-month') {
        this.isLastMonthActive = true
        this.fnPeriodLastMonth()
      } else if (this.isRecordType && this.periodMode == 'this-year') {
        this.isLastYearActive = true
        this.fnPeriodLastYear()
      } else if (!this.isRecordType && this.periodMode == 'this-month') {
        this.isThisMonthActive = true
        this.fnPeriodThisMonthLeads()
      } else if (!this.isRecordType && this.periodMode == 'last-month') {
        this.isLastMonthActive = true
        this.fnPeriodLastMonthLeads()
      } else if (!this.isRecordType && this.periodMode == 'this-year') {
        this.isLastYearActive = true
        this.fnPeriodLastYearLeads()
      }
    }
  },
  created() {
    this.userObj = authService.getUserFromToken()
    this.fetchUserById(this.userObj.id)

    this.currentMonthInText = moment().format('MMMM')
    this.lastMonthInText = moment().subtract(1, 'month').format('MMMM')
    this.currentYearInText = moment().format('YYYY')
  },
  watch: {
    getUserById(val) {
      this.getRPBelongsToUser = val.referral_partners[0]

      this.fetchDRpThisMonthData(this.getRPBelongsToUser.id)
      this.fetchDRpLastMonthData(this.getRPBelongsToUser.id)
      this.fetchDRpLastYearData(this.getRPBelongsToUser.id)

      this.fetchDRpThisMonthLeadsData(this.getRPBelongsToUser.id)
      this.fetchDRpLastMonthLeadsData(this.getRPBelongsToUser.id)
      this.fetchDRpLastYearLeadsData(this.getRPBelongsToUser.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.iq-card-body {
  flex: unset;
}
.btn.btn-secondary {
  background-color: var(--iq-light-primary);
  border: 0px solid transparent !important;
  border-radius: 10px;
  color: var(--iq-primary);
}
.btn.btn-secondary.primary {
  background-color: var(--iq-primary);
  border: 0px solid transparent !important;
  border-radius: 10px;
  color: var(--iq-white);
}
</style>
